
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Button, Card } from "react-bootstrap";
import { useAppDispatch, withSkipGlobalApiError } from "src/redux/storeHooks";
import { loginAsync , validateUserSessionPostAsync} from "src/redux/actions/authActions";
import useAppToast from "src/hooks/useAppToast";
import {
  accessSessionTokenKeyName,
  refreshSessionTokenKeyName,
} from "src/utils/constants";
import { useLocation, useNavigate,Link  } from "react-router-dom";
import { toAbsoluteUrl } from "src/marketConnect/helpers";

// ✅ Validation Schema
const PasswordSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, "Minimum 8 characters")
    .max(50, "Maximum 50 characters")
    .required("Password is required"),
});

const EnterPassword = () => {
  const dispatch = useAppDispatch();
  const { successToast, errorToast } = useAppToast();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
 const { sessionToken,email}: any = location.state || {};


  const handlePasswordSubmit = async (values: { password: string }) => {
    setLoading(true);
    try {
   
   const response = await  dispatch(validateUserSessionPostAsync(withSkipGlobalApiError({session_token:sessionToken,password:values.password})));
      if (response.payload?.access) {
        localStorage.setItem(
          accessSessionTokenKeyName,
          response.payload.access
        );
        localStorage.setItem(
          refreshSessionTokenKeyName,
          response.payload.refresh
        );
        successToast("Logged in successfully ");
        navigate("/dashboard");
      } else {
 if(response.payload?.status=='400' && response.payload?.data?.hasOwnProperty("is_valid") && !response.payload?.data?.is_valid ){
          errorToast(response?.payload?.data?.message);
          navigate("/auth/login");
        }else{errorToast(response?.payload?.data?.message)}
      }
    } catch (err) {
      errorToast("Something went wrong, please try again");
    } finally {
      setLoading(false);
    }
  };

    useEffect(() => {
      if (!location.state) {
        navigate("/auth");
      }
    }, []);

  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
  <Card
    className="text-center"
    style={{
      width: "500px",
      padding: "30px",
      border: "none",
      boxShadow: "none",
      backgroundColor: "#fcfcfc",
    }}
  >
    {/* Logo */}
    <div className="mb-3">
      <a
        href="https://constacloud.com/commercium/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          alt="Logo"
          src={toAbsoluteUrl("/media/logos/favicon.png")}
          className="h-sm-90px h-50px"
        />
      </a>
    </div>

    <h4 className="fw-bold mb-2">Enter Your Password Again</h4>
    {/* <p className="text-muted mb-2" style={{ fontSize: "0.9rem" }}>
      Enter your account password again.
    </p> */}
  <p className="text-muted mb-2" style={{ fontSize: "0.9rem" }}>

      For your security, please re-enter your password to continue
    </p>
    {/* 👇 Login in as line */}
    <p className="fw-semibold mb-4 " style={{ fontSize: "0.95rem" }}>
      Login as: <span className="text-primary">{email}</span>
    </p>

    <Formik
      initialValues={{ password: "" }}
      validationSchema={PasswordSchema}
      onSubmit={handlePasswordSubmit}
    >
      {({ isSubmitting }) => (
        <Form>
          <div className="mb-3">
            <Field
              type="password"
              name="password"
              className="form-control text-center"
              placeholder="Enter your password"
              style={{
                borderRadius: "6px",
                height: "45px",
                fontSize: "1rem",
              }}
            />
            <ErrorMessage
              name="password"
              component="div"
              className="text-danger mt-1 small"
            />
          </div>

          <Button
            type="submit"
            style={{
              border: "none",
              height: "45px",
              fontWeight: "600",
            }}
            className="w-100"
            disabled={isSubmitting || loading}
          >
            {loading ? "Verifying..." : "Confirm"}
          </Button>
        </Form>
      )}
    </Formik>
    <div className='text-gray-500 text-center fw-semibold fs-6 mt-5'>
          Want to sign in different account?{" "}
          <Link to='/auth' className='link-primary'>
            Sign in
          </Link>
        </div>
  </Card>
    
</div>
  );
};

export default EnterPassword;
